import FrozenPackagingModal from './FrozenPackagingModal';

export default FrozenPackagingModal;
